import { TypedDocumentNode, gql } from '@apollo/client'

import {
  DrugSearchPricesQueryResult,
  DrugSearchPricesQueryVariables,
} from './types'

export const DRUG_SEARCH_PRICES_QUERY: TypedDocumentNode<
  DrugSearchPricesQueryResult,
  DrugSearchPricesQueryVariables
> = gql`
  query drugSearchPricesQuery(
    $ndc: String!
    $gpi: String!
    $days_supply: Float!
    $quantity: Float!
    $latitude: Float!
    $longitude: Float!
  ) {
    drugSearchPrices: drugPrices(
      configuration: {
        ndc: $ndc
        gpi: $gpi
        quantity: $quantity
        daysSupply: $days_supply
        latitude: $latitude
        longitude: $longitude
      }
    ) {
      kind: __typename
      ...drugPrices
      ...drugRejection
    }
  }

  fragment drugPrices on RegularDrugPrices {
    daysSupply
    bestPriceId
    prices: pharmacies {
      ...drugPriceUnion
    }
    disclaimers {
      text
      type
    }
  }

  fragment drugPriceUnion on DrugPriceUnion {
    kind: __typename
    ...price
    ...priceRejection
  }

  fragment pharmacyStepContent on PharmacyStepContent {
    content
    type
    url
  }

  fragment pharmacySteps on PharmacySteps {
    content {
      ...pharmacyStepContent
    }
    title
  }

  fragment workSchedule on WorkSchedule {
    closeHour: close_hour
    dayOfWeek: day_of_week
    openHour: open_hour
  }

  fragment anyPharmacy on SharedPharmacy {
    kind: __typename
    nabp
    name
    phone
    pharmacySteps {
      ...pharmacySteps
    }
    isFavorite

    ... on MailOrderPharmacy {
      deliveryTime
    }

    ... on PbmRetailPharmacy {
      workSchedule {
        ...workSchedule
      }
      addressLine1
      city
      state
      zip
      latitude
      longitude
      distance(location: { latitude: $latitude, longitude: $longitude })
    }
  }

  fragment price on RegularDrugPrice {
    id
    planName
    planPay
    patientPay
    pharmacy {
      ...anyPharmacy
    }
    section: sectionType
  }

  fragment priceRejection on DrugPriceReject {
    id
    pharmacy {
      ...anyPharmacy
    }
    section: sectionType
  }

  fragment drugRejection on DrugRejection {
    type: reject_type
    message: reject_message
    description: reject_description
  }
`
